import React from 'react';
import {
  heightLargeIcon,
  heightMediumIcon,
  heightSmallIcon,
  heightXSmallIcon,
} from '../../editorIcons';
import ToolbarButton, { ToolbarButtonGroup } from './ToolbarButton';

type HeightValue = 'xsmall' | 'medium' | 'large' | null;

interface ToolbarHeightButtonGroupProps {
  disallowShortHeight?: boolean;
  height: unknown;
  onHeightChange: (newSpan: HeightValue) => void;
}

const ToolbarHeightButtonGroup = ({
  disallowShortHeight,
  height,
  onHeightChange,
}: ToolbarHeightButtonGroupProps) => (
  <ToolbarButtonGroup aria-label="Height options" role="radiogroup">
    {!disallowShortHeight && (
      <ToolbarButton
        accessibleType="radio"
        icon={heightXSmallIcon}
        tooltip="Short height"
        active={height === 'xsmall'}
        onClick={() => onHeightChange('xsmall')}
      />
    )}
    <ToolbarButton
      accessibleType="radio"
      icon={heightSmallIcon}
      tooltip="Default height"
      active={!height}
      onClick={() => onHeightChange(null)}
    />
    <ToolbarButton
      accessibleType="radio"
      icon={heightMediumIcon}
      tooltip="Medium height"
      active={height === 'medium'}
      onClick={() => onHeightChange('medium')}
    />
    <ToolbarButton
      accessibleType="radio"
      icon={heightLargeIcon}
      tooltip="Tall height"
      active={height === 'large'}
      onClick={() => onHeightChange('large')}
    />
  </ToolbarButtonGroup>
);

export default ToolbarHeightButtonGroup;
